module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notification-components/action-based-notifications/action-notification-list/action-notification-list.component.css
// module id = ./src/app/notification-components/action-based-notifications/action-notification-list/action-notification-list.component.css
// module chunks = main